import React from 'react';
import { inject, observer } from 'mobx-react';
import H5TabNav from './h5';
import PCTabNav from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';

interface TabNavProps {
    app?: AppStore;
    variant?: 'pc' | 'h5';
    navClick: Function  // 导航点击事件
    boxWidth?: any   // 导航所占宽度
    zIndex?: number // 导航显示层级，默认为10 
    boxStylesData?: any // 导航最外层父级盒子自定义样式
    isAlignLeft?: any    // 导航列表样式自定义
    navList: any    // 导航列表数据
    currentIndex?: number  // 当前点击的索引，默认为0，第一个被选中
    showFoldMenu?: any  // 是否显示折叠按钮，默认为false
    foldBgColor?: any //折叠按钮背景色
    showAlias?: any // 是否显示别名
    showRightCornerNum?: boolean    // 是否显示右上角数量
}

@inject('app', 'site', 'user')
@observer
class TabNav extends React.Component<TabNavProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('组件组件');
    }

    render() {
        const { app, variant, navList, ...props } = this.props;
        const platform = variant || app?.platform || 'h5';
        if (platform === 'pc') {
            return <PCTabNav {...props} navList={navList}/>;
        } else {
            return <H5TabNav {...props} navList={navList} />;
        }
        
        
    }
}

export default TabNav;
